export default __webpack_public_path__ + "static/media/Scholar's Armbands of the Effulgent Blade.501d3689.jpg";